import React from "react";
import { useTranslation } from "react-i18next";
import { UniversalGlobe } from "./Icons";

interface CountryDisplayProps {
  countryCode: string;
  countryName: string;
  hideFlag?: boolean;
  hideCountryName?: boolean;
  onClick?: () => void;
  isUniversal?: boolean;
  fontSize?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "4xl";
  countryNameClasses?: string;
}

const CountryDisplay: React.FC<CountryDisplayProps> = ({
  countryCode,
  countryName,
  hideFlag = false,
  hideCountryName = false,
  onClick,
  isUniversal = false,
  fontSize = "sm",
  countryNameClasses = "",
}) => {
  const { t } = useTranslation();
  if (isUniversal) {
    return (
      <div className="flex items-center gap-2">
        <UniversalGlobe color="#5850ec" />
        <span className={`font-medium ${countryNameClasses}`}>{t("common.universal")}</span>
      </div>
    );
  }

  if (!countryCode && !countryName) {
    return "-";
  }

  const clickable = typeof onClick === "function";

  return (
    <div
      className={`flex items-center gap-2 ${clickable ? "cursor-pointer select-none" : ""
        }`}
      onClick={onClick}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? "button" : undefined}
      onKeyDown={
        clickable
          ? (e) => {
            if (e.key === "Enter" || e.key === " ") {
              onClick();
            }
          }
          : undefined
      }
      style={clickable ? { outline: "none" } : undefined}
    >
      {!hideFlag && countryCode && (
        <img
          src={`/images/svg_flags/${countryCode}.svg`}
          alt={countryName}
          className="w-6 h-4 rounded-sm border"
        />
      )}
      {!hideCountryName && countryName && (
        <p
          className={`text-${fontSize} ${countryNameClasses} ${clickable
            ? `text-indigo-700 transition-all ease-in-out hover:ml-1`
            : undefined
            }`}
        >
          {countryName}
        </p>
      )}
    </div>
  );
};

export default CountryDisplay;
